import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { uploadInOneStep, uploadInOneStepFailure, uploadInOneStepSuccess } from './actions';

/** @typedef {{[key: string]: { isLoading: boolean }}} MediaState */

/** @type {MediaState} */
const initialState = {};

const setLoading = (isLoading) => (state, { payload: { key } }) => ({
  ...state,
  [key]: { isLoading },
});

export default createReducer(initialState, (builder) => {
  builder
    .addCase(uploadInOneStep, setLoading(true))
    .addMatcher(isAnyOf(uploadInOneStepSuccess.match, uploadInOneStepFailure.match), setLoading(false));
});
